import { assert_array_has_1_item, assert_instanceof } from '@shared/asserts/utils_asserts';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO__grid2d_cell_generation } from '../grid2d_cell/DTO__grid2d_cell_generation';
import { DTO__grid2d_chunk_generation } from '../grid2d_chunk/DTO__grid2d_chunk_generation';
import { DTO__grid2d } from './DTO__grid2d';

//id = generation_id
//grid2d generation contains unique list of cells by x+y
//contains always 1 chunk
export class DTO__grid2d_generation extends DTO__grid2d {
  static _class_name_static: string = ENUM__dto_class_name.GRID2D_GENERATION;

  /*
   * STATIC FIELDS
   */

  /*
   * DB FIELDS
   */

  user_task_id!: string;

  /*
   * INSTANCE METHODS
   */

  get_generation_chunk(): DTO__grid2d_chunk_generation {
    let out = assert_array_has_1_item(this.chunks, { context: 'chunks' });

    assert_instanceof(out, DTO__grid2d_chunk_generation);

    return out;
  }

  chunk__create_stub() {
    return DTO__grid2d_chunk_generation.CREATE_STUB();
  }

  init_cells_list(cells_list: DTO__grid2d_cell_generation[]) {
    this.total_cells_amount = cells_list.length;
    this.total_images_amount = cells_list.filter(cell => !cell.hash_sha256_content.is_empty_hash_sha256()).length;

    let grid2d_chunk = this.get_generation_chunk();

    grid2d_chunk.cells_amount_before_this_chunk = 0;
    grid2d_chunk.cells_list = cells_list;
    grid2d_chunk.are_cells_loaded_first_time = true;

    grid2d_chunk.images_amount = this.total_images_amount;
  }
}
